import { HashTable } from "../../../../../helper/hash-table";
import { Direction } from "../../../../components/mosaic/mosaic-node/mosaic-node.component";
import { IMosaic } from "../../../../components/mosaic/mosaic.component";

export const templates: IMosaic[] = [
  {
   
    node: {
      settings: {
        updateTime: "60"
      },
      size: 100
    }
  } as IMosaic,
  {
    
    direction: Direction.horizontal,
    node: {
      nodes: [
        {
          settings: {
            updateTime:"60"
          },
          size:50
        },
        {
          settings: {
            updateTime: "240"
          },
          size: 50
        }
      ]
    }
  } as IMosaic,
  {
     
    direction: Direction.vertical,
    node: {
      nodes: [
        {
          settings: {
            updateTime: "240"
          },
          size: 50
        },
        {
          settings: {
            updateTime: "60"
          },
          size: 50
        }
      ]
    }
  } as IMosaic,
  {
    
    direction: Direction.vertical,
    node: {
      nodes: [
        {
          nodes: [
            {
              settings: {
                updateTime: "60"
              },
              size: 50
            },
            {
              settings: {
                updateTime: "240"
              },
              size: 50
            }
          ]
        },
        {
          nodes: [
            {
              settings: {
                updateTime: "15"
              },
              size: 50
            },
            {
              settings: {
                updateTime: "5"
              },
              size: 50
            }
          ]
        }
      ]
    }
  } as IMosaic
]; 
